module.exports = __webpack_public_path__ + "img/Orbiting-2-mobile.da22749b.png";